<template>
  <main id="main" class="main-site">
    <div v-if="changepassword == 'STEP1'">
      <div class="container">
        <div class="main-content-area">
          <div class="wrap-form-item">
            <div class="container padding-bottom-3x mb-2 mt-5">
              <div class="row justify-content-center">
                <div class="col-md-6" style="align-content: center; margin-top: 20px">
                  <div class="panel panel-default">
                    <div class="panel-body">
                      <div class="text-center">
                        <div v-if="frmRecuperarSenha.sendPassword == false">
                          <h5><i class="fa fa-lock fa-4x"></i></h5>
                          <h2 class="text-center">{{ titulo }}</h2>
                        </div>
                        <div v-else>
                          <h5><i class="fa fa-lock fa-4x"></i></h5>
                          <h2 class="text-center">E-mail Enviado</h2>
                        </div>
                        <hr />
                        <div v-if="frmRecuperarSenha.sendPassword == false">
                          <p>Informe seu CNPJ e enviaremos. <br />Instruções para você criar sua senha.</p>
                        </div>
                        <div v-else>
                          <p>Enviamos um e-mail com instruções para a criação de uma nova senha para:</p>
                        </div>
                        <hr />
                        <div v-if="frmRecuperarSenha.sendPassword == true">
                          <p>{{ frmRecuperarSenha.sendmail }}</p>
                        </div>
                        <div>
                          <div class="panel-body">
                            <form
                              id="register-form"
                              role="form"
                              autocomplete="off"
                              class="form"
                              method="post"
                              name="frm-alterar-dados-atuais"
                              @submit.prevent="recuperar"
                            >
                              <div v-if="frmRecuperarSenha.sendPassword == true">
                                <div>
                                  <b>Ainda não recebeu o e-mail?</b>
                                </div>
                              </div>
                              <div v-if="frmRecuperarSenha.sendPassword == false" class="form-group">
                                <input
                                  type="text"
                                  id="frm-cnpj"
                                  name="f-name-cnpj"
                                  class="form-control form-control-lg"
                                  placeholder="00.000.000/00000-00"
                                  v-model="frmRecuperarSenha.cnpj"
                                  v-mask="'##.###.###/####-##'"
                                />
                                <span v-if="!isCnpjValid.status && frmRecuperarSenha.attemptSubmit" class="invalid-feedback">{{
                                  isCnpjValid.message
                                }}</span>
                              </div>

                              <div class="form-group">
                                <p style="text-align: left"><b>Verificação de Segurança</b></p>
                                <div runat="server" id="divRecaptcha">
                                  <div class="g-recaptcha" data-sitekey="6LcpQhcTAAAAAB-QnUnNKlJPkEDRTp17DGgvCL7n"></div>
                                  <br />
                                  <button aria-labe="Enviar" class="btn btn-lg btn-primary btn-block" ref="btnEnviarEmail">Enviar</button>
                                </div>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="changepassword == 'STEP2'">
      <div class="container">
        <div class="main-content-area">
          <div class="wrap-form-item">
            <div class="container padding-bottom-3x mb-2 mt-5">
              <div class="row justify-content-center">
                <div class="col-md-6" style="align-content: center; margin-top: 20px">
                  <div class="panel panel-default">
                    <div class="panel-body">
                      <div class="text-center">
                        <div v-if="frmRecuperarSenha.sendPassword == false">
                          <h5><i class="fa fa-lock fa-4x"></i></h5>
                          <h2 class="text-center">Cadastre sua senha</h2>
                        </div>
                        <hr />
                        <div>
                          <p>
                            A senha deve possuir no mínimo 8 caracteres,<br />
                            letras maiúsculas, minúsculas e números
                          </p>
                        </div>
                        <div>
                          <div class="panel-body">
                            <form
                              id="register-form"
                              role="form"
                              autocomplete="off"
                              class="form"
                              method="post"
                              name="frm-alterar-senha"
                              @submit.prevent="alterarsenha"
                            >
                              <div class="form-group">
                                <label for="frm-password" class="text-info">Crie sua nova senha:</label><br />
                                <input
                                  id="frm-password"
                                  name="f-name-password"
                                  class="form-control"
                                  v-mask="mask"
                                  v-model="frmAlterarSenha.newpassword"
                                  :class="{ valid: passwordValidation.valid }"
                                  :type="passwordVisible ? 'text' : 'password'"
                                />
                              </div>
                              <div class="form-group">
                                <label for="frm-confirmpassword" class="text-info">Confirme a sua nova senha:</label><br />
                                <input
                                  type="password"
                                  id="frm-confirmpassword"
                                  name="f-name-confirmpassword"
                                  class="form-control"
                                  v-mask="mask"
                                  v-model.lazy="frmAlterarSenha.newpasswordconfirmation"
                                />
                                <transition name="hint" appear>
                                  <div v-if="passwordValidation.errors.length > 0 && !submitted" class="hints">
                                    <h2 style="font-size: 17px; font-weight: 600; color: #bf4917">Preencha os requisitos da senha:</h2>
                                    <p v-for="error in passwordValidation.errors" style="margin-bottom: 1px; color: red">{{ error }}</p>
                                  </div>
                                </transition>
                                <div class="matches" v-if="notSamePasswords">
                                  <p style="color: red">Senhas não conferem.</p>
                                </div>
                              </div>
                              <div v-if="passwordValidation.errors.length == 0" class="form-group">
                                <div runat="server">
                                  <button aria-label="Alterar Senha" class="btn btn-lg btn-primary btn-block">Cadastrar Senha</button>
                                </div>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="changepassword == 'STEP3'">
      <div class="container">
        <div class="main-content-area">
          <div class="wrap-form-item">
            <div class="container padding-bottom-3x mb-2 mt-5">
              <div class="row justify-content-center">
                <div class="col-md-6" style="align-content: center; margin-top: 20px">
                  <div class="panel panel-default">
                    <div class="panel-body">
                      <div class="text-center">
                        <div v-if="frmRecuperarSenha.sendPassword == false">
                          <h5><i class="fa fa-lock fa-4x"></i></h5>
                          <h2 class="text-center">Senha Criada!</h2>
                        </div>
                        <hr />
                        <div>
                          <p>A partir de agora use sua nova senha para fazer login no site Aldo.com.br</p>
                        </div>
                        <div>
                          <div class="panel-body">
                            <a aria-labe="Site Aldo" :href="`${$SiteUrl}/login`" class="btn btn-lg btn-primary btn-block">Ir para o Site</a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: 'RecuperarSenha',
  props: {
    msg: String,
  },
  data() {
    return {
      rules: [
        { message: 'Falta uma letra minúscula.', regex: /[a-z]+/ },
        { message: 'Falta uma letra maiúscula.', regex: /[A-Z]+/ },
        { message: 'Mínimo de 8 caracteres.', regex: /.{8,}/ },
        { message: 'Falta um número.', regex: /[0-9]+/ },
      ],
      passwordVisible: false,
      submitted: false,
      changepassword: 'STEP1',
      titulo: 'Esqueceu sua senha?',
      frmRecuperarSenha: {
        cnpj: '',
        attemptSubmit: false,
        sendPassword: false,
        sendmail: '',
      },
      frmAlterarSenha: {
        codigo: '',
        newpassword: '',
        newpasswordconfirmation: '',
        attemptSubmit: false,
      },
    }
  },
  computed: {
    isCnpjValid: function () {
      const re = /([0-9]{2}[\.]?[0-9]{3}[\.]?[0-9]{3}[\/]?[0-9]{4}[-]?[0-9]{2})/
      const cnpj = this.frmRecuperarSenha.cnpj

      const response = {}
      if (!cnpj || !re.test(cnpj) || !this.testCnpj(cnpj)) {
        response.status = false
        response.message = 'Por favor, preencha o CNPJ corretamente'
      } else {
        response.status = true
      }

      return response
    },
    notSamePasswords() {
      if (this.passwordsFilled) {
        return this.frmAlterarSenha.newpassword !== this.frmAlterarSenha.newpasswordconfirmation
      } else {
        return false
      }
    },
    passwordsFilled() {
      return this.frmAlterarSenha.newpassword !== '' && this.frmAlterarSenha.newpasswordconfirmation !== ''
    },
    passwordValidation() {
      let errors = []
      for (let condition of this.rules) {
        if (!condition.regex.test(this.frmAlterarSenha.newpassword)) {
          errors.push(condition.message)
        }
      }
      if (errors.length === 0) {
        return { valid: true, errors }
      } else {
        return { valid: false, errors }
      }
    },
  },

  created() {
    if (this.$route.params.id == null) {
      let recaptchaScript = document.createElement('script')
      recaptchaScript.setAttribute('src', 'https://www.google.com/recaptcha/api.js')
      document.head.appendChild(recaptchaScript)
      this.changepassword = 'STEP1'
      if (this.$route.path == '/primeiro-acesso') this.titulo = 'Cadastre sua senha para primeiro acesso'
    } else {
      var obj = this
      var pid = this.$route.params.id
      var ptoken = this.$route.params.token
      var xhr = new XMLHttpRequest()
      xhr.onload = () => {
        var texto = JSON.parse(xhr.responseText)
        if (xhr.status == 200) {
          obj.changepassword = 'STEP2'
          obj.frmAlterarSenha.codigo = texto
        } else {
          obj.changepassword = 'STEP1'
        }
      }
      xhr.open('POST', this.$apiUrl + 'Login.svc/LoadToken')
      xhr.setRequestHeader('Content-Type', 'application/json')
      xhr.withCredentials = true
      xhr.send(JSON.stringify({ id: pid, token: ptoken }))
    }
  },
  methods: {
    recuperar: function (e) {
      // Notifica que submit já foi realizado
      this.frmRecuperarSenha.attemptSubmit = true
      // Verifica se os dados são válidos
      if (this.isCnpjValid.status) {
        // Caso os dados sejam válidos, realiza a post com o servidor
        this.recuperarSenha(this.frmRecuperarSenha.cnpj)
      }
    },
    alterarsenha: function () {
      this.frmAlterarSenha.attemptSubmit = true
      this.changePasswordMethod()
    },
    recuperarSenha: function (newData) {
      var obj = this
      //Realiza post para server
      var xhr = new XMLHttpRequest()
      xhr.onload = () => {
        const response = JSON.parse(xhr.responseText)
        const texto = response.Item1
        if (xhr.status == 200) {
          if (texto === 'Pre-Cadastro') {
            localStorage.setItem('precadastro', response.Item2)

            location.href = `/cadastro-simplificado/${newData.replaceAll('.', '').replace('/', '').replace('-','')}`
            return
          }

          obj.frmRecuperarSenha.sendPassword = true
          obj.frmRecuperarSenha.sendmail = JSON.parse(xhr.responseText).Item2
          obj.$refs.btnEnviarEmail.innerText = 'Reenviar E-mail'
          swal({
            title: texto,
            icon: 'success',
          })
        } else {
          swal({
            title: texto,
            icon: 'error',
          })
          obj.$refs.btnEnviarEmail.innerText = 'Enviar E-mail'
        }
      }

      xhr.open('POST', this.$apiUrl + 'Login.svc/recuperapassword')
      xhr.setRequestHeader('Content-Type', 'application/json')
      xhr.withCredentials = true
      xhr.send(JSON.stringify({ cnpj: newData }))
    },
    changePasswordMethod: function () {
      var obj = this
      var pcodigo = this.frmAlterarSenha.codigo
      var newpassword = this.frmAlterarSenha.newpassword
      var newpasswordConfirmation = this.frmAlterarSenha.newpasswordconfirmation
      var pid = this.$route.params.id
      var ptoken = this.$route.params.token
      var xhr = new XMLHttpRequest()
      xhr.onload = () => {
        if (xhr.status == 200) {
          var LoadAlterarSenha = JSON.parse(xhr.responseText)
          if (LoadAlterarSenha == 'SENHA DIVERGENTE') {
            swal({
              title: 'Senhas divergentes',
              icon: 'error',
            })
          } else if (LoadAlterarSenha == 'OK') {
            obj.changepassword = 'STEP3'
          }
        } else {
          swal({
            title: 'Erro ao alterar senha',
            icon: 'error',
          })
        }
      }
      xhr.open('POST', this.$apiUrl + 'Login.svc/changepassword')
      xhr.setRequestHeader('Content-Type', 'application/json')
      xhr.withCredentials = true
      xhr.send(JSON.stringify({ codigo: pcodigo, password: newpassword, confirmationpassword: newpasswordConfirmation, token: ptoken, id: pid }))
    },

    testCnpj: function (c) {
      var b = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]

      if ((c = c.replace(/[^\d]/g, '')).length != 14) return false

      if (/0{14}/.test(c)) return false

      for (var i = 0, n = 0; i < 12; n += c[i] * b[++i]);
      if (c[12] != ((n %= 11) < 2 ? 0 : 11 - n)) return false

      for (var i = 0, n = 0; i <= 12; n += c[i] * b[i++]);
      if (c[13] != ((n %= 11) < 2 ? 0 : 11 - n)) return false

      return true
    },
  },
}
</script>
